import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { EmpresasModule } from '../empresas/empresas.module';
import { PrismaModule } from '../prisma/prisma.module';
import { SucursalesModule } from '../sucursales/sucursales.module';
import { PuntoExpedicionesController } from './punto-expediciones.controller';
import { PuntoExpedicionesService } from './punto-expediciones.service';

@Module({
  imports: [PrismaModule, SucursalesModule, EmpresasModule],
  controllers: [PuntoExpedicionesController],
  providers: [PuntoExpedicionesService],
  exports: [PuntoExpedicionesService],
})
export class PuntoExpedicionesModule {}
